




















































































import { Component, Vue } from 'vue-property-decorator';

import DialogBase from '@/components/common/DialogBase';
import { createSlackAPI, SlackAPI } from '@/repo/slack';
import appInfo from '@/store/modules/AppInfoModule';

@Component({
  components: {},
})
export default class FeedbackCard extends Vue {
  private summary = '';
  private description = '';

  private file: File | null = null;
  private fileURL: string | null = null; // preview用 fileがnullの場合は必ずnull

  private isPickingFile = false;
  private isPostingFeedback = false;

  private get input() {
    return this.$refs.input as HTMLInputElement;
  }

  get slackAPI(): SlackAPI {
    return createSlackAPI(
      appInfo.envName ?? 'unknown',
      this.summary,
      this.description,
      this.file
    );
  }

  async postFeedback() {
    if (this.summary == '' || this.description == '') {
      console.log('summary or description (or both) is empty');
      return;
    }

    this.isPostingFeedback = true;
    try {
      await this.slackAPI.perform();
      console.log('postFeedback: OK');
      this.$toast('フィードバックを送信しました。ありがとうございます。', {
        color: 'green',
        icon: '',
      });
    } catch (e) {
      console.log(`postFeedback: ERR=${e}`);
      this.$toast('エラーが発生しました。開発者に報告していただきたいです...', {
        color: 'red',
        icon: '',
      });
      return;
    } finally {
      this.isPostingFeedback = false;
    }

    this.summary = '';
    this.description = '';
    this.unpickFile();
    this.$emit('close');
  }

  showFilePicker() {
    this.isPickingFile = true;
    window.addEventListener(
      'focus',
      () => {
        this.isPickingFile = false;
      },
      { once: true }
    );
    this.input.click();
  }

  onFilePicked() {
    if (!this.input.files) {
      return;
    }

    const f = this.input.files[0];
    if (!f.type.startsWith('image')) {
      // valueをクリアしておかないとunpick -> re-pickで同じファイルを選択した場合にinputの@changeが発火しない
      this.input.value = '';
      this.$toast(
        '申し訳ありませんが、拡張子付きの画像ファイルでお願いします。',
        {
          color: 'red',
          icon: '',
        }
      );
      return;
    }

    this.file = f;
    this.fileURL = URL.createObjectURL(this.file);
  }

  unpickFile() {
    this.file = null;
    this.fileURL = null;

    // valueをクリアしておかないとunpick -> re-pickで同じファイルを選択した場合にinputの@changeが発火しない
    this.input.value = '';
  }

  onPaste(event: ClipboardEvent, visibleError = true) {
    const items = event.clipboardData?.items ?? [];
    if (items.length > 0 && items[0].type === 'image/png') {
      const file = items[0].getAsFile();
      if (file != null) {
        this.fileURL = URL.createObjectURL(file);
        this.file = file;
      }
    } else {
      this.resetDropAndPasteBox();
      if (visibleError) {
        this.$toast.error('画像のみ張り付け可能です');
      }
    }
  }

  onDrop(event: DragEvent) {
    const file = event.dataTransfer?.files[0];
    if (file != null && file.type === 'image/png') {
      this.fileURL = URL.createObjectURL(file);
      this.file = file;
    } else {
      this.resetDropAndPasteBox();
      this.$toast.error('画像のみ張り付け可能です');
    }
  }

  resetDropAndPasteBox() {
    // event発火時にはまだ存在しないので、一瞬待ってから削除を実行
    window.setTimeout(() => {
      const dropAndPasteBox = this.$refs.dropAndPasteBox as Element;
      console.log(dropAndPasteBox);
      while (dropAndPasteBox.firstChild)
        dropAndPasteBox.removeChild(dropAndPasteBox.firstChild);
    }, 1);
  }
}
